import React from 'react';

import FormItem from './form-item';
import BasicDropdown from '../../base/dropdowns/basic-dropdown';

const MerchantAuctionSetup = (
  pricingModels,
  currentPricingModel,
  setCurrentPricingModel,
  maxCPC,
  setMaxCPC,
  roiGoal,
  setRoiGoal,
  shareGoal,
  setShareGoal,
  goalCPC,
  setGoalCPC,
  comission,
  setComission,
  pacing,
  setPacing,
) => {
  const inputs = [
    { value: maxCPC, setter: setMaxCPC, label: 'Max CPC' },
    { value: roiGoal, setter: setRoiGoal, label: 'ROI Goal' },
    { value: shareGoal, setter: setShareGoal, label: 'Share Goal' },
    { value: goalCPC, setter: setGoalCPC, label: 'Goal CPC' },
    { value: comission, setter: setComission, label: 'Commission' },
  ];

  const inputItems = inputs.map(({ value, setter, label }, idx) => (
    <FormItem key={idx} value={value} setter={setter} label={label} />
  ));

  return (
    <div className="form">
      <div className="form-item pricing-model">
        <label>Pricing Model</label>
        <div className="auction-type">
          <BasicDropdown
            items={pricingModels}
            selectItem={idx => setCurrentPricingModel(pricingModels[idx])}
            dropdownLabel={currentPricingModel.label}
          />
          <div className="checkbox-label pacing">
            <span
              className={`checkbox ${pacing ? 'selected' : ''}`}
              onClick={() => setPacing(!pacing)}
            ></span>
            <span className="checkbox-text">Pacing Enabled</span>
          </div>
        </div>
      </div>
      {inputItems}
    </div>
  );
};

export default MerchantAuctionSetup;
